var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"mailto:fcx@fp-forum.org"}},[_vm._v("fcx@fp-forum.org")])}
var staticRenderFns = []

export { render, staticRenderFns }